/** @jsxImportSource @emotion/react */
import React, { useEffect } from "react";
import OrderInProgressGif from "../../img/trade-interface/order_in_progress.gif";
import { GlobalStore } from "../../store/global/GlobalStore";
import { YouPaySection } from "../../components/Modal/instance/ConfirmTrade/YouPaySection";
import { YouReceiveSection } from "../../components/Modal/instance/ConfirmTrade/YouReceiveSection";
import { TradeDetailsSection } from "../../components/DetailsSection/TradeDetailsSection";
import { Amount } from "../../types/amount";
import { OrderStatus } from "../../types/orderStatus";
import { ProgressBar } from "../../components/ProgressBar/ProgressBar";
import { ReviewActionButton } from "./ReviewActionButton";
import { getOrderType } from "../../utils/orderTypeUtils";
import { RandomMessage } from "../../components/RandomMessage/RandomMessage";
import * as Sentry from "@sentry/react";
import { Spacer } from "../../components/general/Spacer/Spacer";
import { getIsWrapOrUnwrap } from "utils/tokenSelectorUtils";

export interface OrderInProgressProps {}

export const OrderInProgress: React.FC<OrderInProgressProps> = () => {
  const orderStatus = GlobalStore.useState(s => s.orderStatus);
  const { networkFee } = GlobalStore.useState(s => {
    return { networkFee: s.quote?.usdGasFee };
  });
  const { network, address, quote, wrapQuote, orderType, makerTokens, takerTokens, chain } =
    GlobalStore.useState(s => {
      return {
        network: s.network,
        address: s.address,
        quote: s.quote,
        wrapQuote: s.wrapQuote,
        orderType: getOrderType(s),
        makerTokens: s.makerTokens,
        takerTokens: s.takerTokens,
        chain: s.network,
      };
    });
  const isWrapOrUnwrap = getIsWrapOrUnwrap(
    takerTokens.map(t => t.token),
    makerTokens.map(t => t.token),
    chain
  );

  Sentry.setContext("order", {
    status: orderStatus,
    // Quote
    ...quote,
    ...network,
    orderType,
    makerTokens,
    takerTokens,
    address,
  });

  useEffect(() => {
    GlobalStore.update(s => {
      s.modalSelector = undefined;
    });
  }, []);

  return (
    <>
      <div className="review-order">
        <div className="col-12 text-center">
          <h5 className="w-100 text-center m-0 trade">Order In Progress</h5>
        </div>
        <div className="sp10"></div>
        <div className="col-12 text-center">
          <img src={OrderInProgressGif} width={115} height={116} alt="Order is in progress" />
          <div className="sp12"></div>
          <RandomMessage />
        </div>
        <div className="sp12"></div>
        <div>
          <YouPaySection shouldDisplayLabel />
          <YouReceiveSection shouldDisplayLabel />
        </div>
        {orderStatus === OrderStatus.IN_PROGRESS && !isWrapOrUnwrap && (
          <>
            <Spacer height="22px" />
            <TradeDetailsSection networkFee={networkFee ?? Amount.ZERO} visible={true} />
          </>
        )}
        {orderStatus === OrderStatus.IN_PROGRESS && <Spacer height="10px" />}
        <div className={"progress-bar-container"}>
          <ProgressBar step={3} />
        </div>
        {(quote != null || wrapQuote != null) && orderType && <ReviewActionButton />}
      </div>
    </>
  );
};
